<template>
  <path
    fill="currentColor"
    d="M6.34315 8.20711L12 2.55026L17.6569 8.20711C20.781 11.3313 20.781 16.3966 17.6569 19.5208C14.5327 22.645 9.46734 22.645 6.34315 19.5208C3.21895 16.3966 3.21895 11.3313 6.34315 8.20711Z"
    stroke-width="2"
  />
</template>
